import { Stack } from '@mui/material';
import { Header } from 'common/ui/Header';
import { CampaignCreationNextButton } from 'modules/campaign-creation/components/CampaignCreationNextButton';
import { CampaignCreationCancelButton } from 'modules/campaign-creation/components/CampaignCreationCancelButton';
import { Input } from 'components/Inputs/Input';
import { useFormik } from 'formik';
import { useCampaignCreationStore } from 'modules/campaign-creation/stores/useCampaignCreationStore';
import { Paths } from 'services/navigation/paths';
import * as Yup from 'yup';
import { useSaveStateCampaign } from 'modules/campaign-creation/hooks/useSaveStateCampaign';
import { getTitle } from 'modules/campaign-creation/utils/getTitle';

export const CampaignCreationEngagementDescriptionStep: React.FC = () => {
  const state = useCampaignCreationStore((store) => store.state);
  const campaignId = useCampaignCreationStore((store) => store.campaignId);
  const engagementDescriptionState = useCampaignCreationStore(
    (store) => store.state?.engagementDescriptionState
  );
  const onEngagementDescriptionBack = useCampaignCreationStore(
    (store) => store.onEngagementDescriptionBack
  );
  const onEngagementDescriptionSubmit = useCampaignCreationStore(
    (store) => store.onEngagementDescriptionSubmit
  );

  const formik = useFormik({
    initialValues: {
      outreachDescription:
        engagementDescriptionState?.outreachDescription ?? '',
      title: engagementDescriptionState?.title ?? ''
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required('Name is required')
        .max(80, 'Must be 80 characters or less'),
      outreachDescription: Yup.string()
        .required('Description is required')
        .max(30000, 'Must be 30000 characters or less')
    }),
    onSubmit: (values) => {
      onEngagementDescriptionSubmit(values);
    }
  });

  useSaveStateCampaign({
    outreachDescription: formik.values.outreachDescription,
    title: formik.values.title
  });

  return (
    <>
      <Header
        currentBreadcrumb={getTitle(state)}
        title="Campaign description"
        breadcrumbs={[{ name: 'Campaigns', path: Paths.CAMPAIGNS }]}
        onBack={() => onEngagementDescriptionBack()}
      />
      <Stack gap="30px">
        <Input
          label="Campaign name"
          sx={{
            width: '700px'
          }}
          maxCharacters={80}
          id="title"
          name="title"
          value={formik.values.title}
          onChange={formik.handleChange}
          error={!!formik.errors.title && formik.touched.title}
          errorText={formik.errors.title}
          onBlur={formik.handleBlur}
        />
        <Input
          label="Add reference information"
          subLabel="E.g. describe the documents, references or feedback you need. This cannot be changed once the campaign is live."
          sx={{
            width: '900px'
          }}
          maxCharacters={30000}
          multiline
          rows={16}
          id="outreachDescription"
          name="outreachDescription"
          value={formik.values.outreachDescription}
          onChange={formik.handleChange}
          error={
            !!formik.errors.outreachDescription &&
            formik.touched.outreachDescription
          }
          errorText={formik.errors.outreachDescription}
          onBlur={formik.handleBlur}
        />
        <Stack direction="row" gap="15px">
          <CampaignCreationNextButton handleNext={formik.handleSubmit} />
          <CampaignCreationCancelButton campaignId={campaignId} />
        </Stack>
      </Stack>
    </>
  );
};
